module.exports = __webpack_public_path__ + "08c7c80fa8a41ab05006f97a06227e2e.pdf";